export default "__VITE_ASSET__C95nOrJw__"